// JED-926: an empty Class Insights view says why it is empty, not just "No data available".
// In order: the data couldn't load, the teacher has no class, nothing was submitted for a
// class task in the filtered view, or that work hasn't been marked with this tool yet.
// The tools only chart class tasks, so independent study never counts here.

const TOOLS = {
  commentBank: {
    title: 'No comment bank feedback yet',
    marked: 'had feedback from a comment bank',
  },
  successCriteria: {
    title: 'No success criteria feedback yet',
    marked: 'been assessed against success criteria',
  },
  rubric: { title: 'No rubric marks yet', marked: 'been marked with a rubric' },
  shortAnswer: {
    title: 'No short answer marks yet',
    marked: 'been marked with a short answer tool',
  },
};

const TRY_ANOTHER_VIEW = 'Try another task or a wider date range.';

export const UNAVAILABLE = {
  message: "Class Insights couldn't load",
  detail: 'Refresh the page to try again.',
};

// The graph and the table come from separate requests; when only the graph is empty the
// marks are still in the table.
export const NO_GRAPH_FOR_MARKS = {
  message: 'No graph for these marks',
  detail: 'Switch to the table view to see them.',
};

export const NO_CLASSES = {
  message: 'No classes yet',
  detail: 'Class Insights fills in once you teach a class with students in it.',
};

// classwork: class task submissions in the same filtered view (the KPI query), or
// null/undefined while that count is loading or refreshing.
export function emptyStateCopy({ tool, hasClasses, classwork, unavailable }) {
  if (unavailable) return UNAVAILABLE;
  if (!hasClasses) return NO_CLASSES;
  if (classwork === 0) {
    return {
      message: 'No class task submissions in this view',
      detail: `Nothing was submitted for a class task in the selected classes, tasks and dates. ${TRY_ANOTHER_VIEW}`,
    };
  }
  const { title, marked } = TOOLS[tool];
  if (!classwork) return { message: title, detail: TRY_ANOTHER_VIEW };
  return {
    message: title,
    detail:
      classwork === 1
        ? `The class task submission in this view hasn't ${marked} yet.`
        : `None of the ${classwork} class task submissions in this view has ${marked} yet.`,
  };
}
